// extracted by css-extract-rspack-plugin
export default {"cls1":"ReaderMessageModal-cls1_Qf2","cls2":"ReaderMessageModal-cls2_Lkw ReaderMessageModal-cls1_Qf2"};